import WalletClient from './walletClient.js'
import ProofClient from './proofClient.js'
import DropClient from './dropClient.js'
import ShippingClient from './shippingClient.js'
import OrderClient from './orderClient.js'
import { initGet, initPost, initPut, initPatch } from './requests.js'
import PartnerClient from './partnerClient.js'
import SiteClient from './siteClient.js'
import ClaimClient from './claimClient.js'

export default class MarketplaceClient {
  constructor({ ethereum, url, _log, _fetch,
    chainId, readContract, prepareWriteContract, writeContract, getNetwork, switchNetwork, waitForTransaction, signMessage
  }) {
    _fetch = _fetch || fetch
    _log = _log || console.log

    const _get = initGet({_fetch, _log})
    const _post = initPost({_fetch, _log})
    const _put = initPut({_fetch, _log})
    const _patch = initPatch({_fetch, _log})

    const params = { ethereum, url, _fetch,
      chainId, readContract, prepareWriteContract, writeContract, getNetwork, switchNetwork, waitForTransaction, signMessage,
      _log, _get, _post, _put, _patch
    }
    this.walletClient = new WalletClient(params)
    this.proofClient = new ProofClient(params)
    this.dropClient = new DropClient(params)
    this.shippingClient = new ShippingClient(params)
    this.orderClient = new OrderClient(params)
    this.partnerClient = new PartnerClient(params)
    this.siteClient = new SiteClient(params)
    this.claimClient = new ClaimClient(params)
  }

  proof() {
    return this.proofClient
  }

  wallet() {
    return this.walletClient
  }

  drop() {
    return this.dropClient
  }

  shipping() {
    return this.shippingClient
  }

  order() {
    return this.orderClient
  }

  partner() {
    return this.partnerClient
  }

  claim() {
    return this.claimClient
  }

  site() {
    return this.siteClient
  }
}
